<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-08-30 19:14:35
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-11-08 08:47:59
 * @FilePath: \official_website\src\views\solution\Solution.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%A
-->
<!-- 解决方案 -->
<template>
  <div id="solution">
    <Header></Header>
    <div class="solution-content">
      <div class="solution-header">
        <img src="@/assets/image/product/header.png" alt="解决方案" />
        <p class="title animate__animated animate__fadeInDown">解决方案</p>
      </div>

      <div class="solution-box">
        <div
          class="solution-list"
          v-for="(items, indexs) in solutionList"
          :key="indexs"
        >
          <div class="list-header">
            <div class="line"></div>
            <div class="title">{{ items.title }}</div>
          </div>
          <ul class="list-content">
            <li
              class="item"
              v-for="(item, index) in items.children"
              :key="index"
              @click="tapPages(item.path)"
            >
              <!-- <img :src="item.src" alt="" /> -->
              <div class="prod-img" :style="{ 'background-image': `url(${item.src}` }"></div>
              <div class="describe">{{ item.lable }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import Header from "../componets/Header.vue";
import Footer from "../componets/Footer.vue";
export default {
  name: "",
  props: {},
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      solutionList: [
        {
          title: "解决方案",
          children: [
             {
              src: require("@/assets/image/product/solution3.png"),
              lable: "宫颈癌筛查解决方案",
              path: "/solution/tbs",
              prodId: 29
            },
            {
              src: require("@/assets/image/product/solution1.png"),
              lable: "DNA倍体癌症早筛解决方案",
              path: "/solution/dna",
              prodId: 28
            },
            {
              src: require("@/assets/image/product/solution4.png"),
              lable: "远程病理诊断解决方案",
              path: "/solution/telepathology",
              prodId: 27
            },
            {
              src: require("@/assets/image/product/solution2.png"),
              lable: "血液细胞形态诊断解决方案",
              path: "/solution/blood",
              prodId: 26
            },
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    tapPages(path) {
      this.$router.push(path);
    },
  },
};
</script>
    
<style lang="scss">
#solution {
  .solution-content {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    .solution-header {
      position: relative;
      img {
        width: 100%;
      }
      .title {
        position: absolute;
        left: 8%;
        top: 40%;
        transform: translateY(-50%);
        color: #fff;
        font-size: 2.4rem;
        font-family: "SourceHanSansSC-Medium";
      }
    }
    .solution-box {
      padding: 3% 8%;
      background-color: #fff;
      .solution-list {
        margin-bottom: 3.75rem;
        .list-header {
          margin-bottom: 1.75rem;
          .line {
            width: 3.75rem;
            height: 0.375rem;
            background: #0b847b;
            margin-bottom: 0.625rem;
          }
          .title {
            font-size: 1.6rem;
            font-family: "SourceHanSansSC-Medium";
          }
        }
        .list-content {
          display: flex;
          flex-wrap: wrap;
          .item {
            width: 23.5%;
            margin-right: 2%;
            box-sizing: border-box;
            margin-bottom: 1.75rem;
            &:nth-of-type(4n) {
              margin-right: 0;
            }
            &:hover .prod-img {
              // transform: scale(1.05);
              background-size: 110%;
              border-color: #0b847b;
            }
            &:hover .describe {
              color: #0b847b;
            }
            .prod-img {
              width: 100%;
              height: 18rem;
              border: 2px dashed #bababa;
              margin-bottom: 1rem;
              cursor: pointer;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center center;
              transition: all 0.8s ease-in-out;
            }
            .describe {
              font-family: "OPlusSans3-Regular";
              font-size: 1.2rem;
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 6.25rem 8% 3.125rem;
  }
}
</style>